import { Component, Output, EventEmitter, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatePipe } from '@angular/common';

import { FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { MatOption } from '@angular/material';

import { GlobalsPaths } from '../../../app.config';
import { WeekPipe } from '../../../_services/weekPipe.service';
import { VehiclesGroupsService } from '../../../_services/vehicles-groups.service';
import { APIsettings } from '../../../app.config';
import { PaginationParams } from '../../../_models/generic';
import { IEventType } from '../../../_models/tracker';
import * as moment from 'moment';
import { timingSafeEqual } from 'crypto';
import { IMyDrpOptions, IMyDateRange } from 'mydaterangepicker';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { EventsSidebarComponent } from '../../../Events/components/events-sidebar/events-sidebar.component';
import { VehiclesFilesService } from '../../../_services/vehicles-files.service';
import { VehicleActivityTypes, VehicleGroupDepots } from '../../../_models/vehicle-file';
import { finalize, tap, switchMap, debounceTime, distinctUntilChanged, map, takeUntil, skip } from 'rxjs/operators';
import { VehiclesService } from 'app/_services/vehicles.service';
import { SimpleVehicleFmt, Vehicle } from 'app/_models/vehicle';
import { fromEvent } from 'rxjs/observable/fromEvent';




@Component({
    moduleId: module.id,
    selector: 'vehicle-file-sidebar',
    templateUrl: `./vehicle-file-sidebar.html`,
    styleUrls: ['./vehicle-file-sidebar.scss']
})

export class VehicleFilterSidebarComponent implements OnInit, OnDestroy {
    static LOCALSTORE_SELECTED_VEHICLE_NAME = 'selectedVehicle';
    static LOCALSTORE_SEARCH_FIELDS_NAME = 'searchFields';
    static LOCALSTORE_SEARCH_DATE_DAY = 'dateDay';


    img: string = this.globalsPaths.img;
    selectedVehicle: SimpleVehicleFmt = null;
    isLoading: boolean = true;
    vehicleCtrl: FormControl;
    searchAutocomplete: string; // selcted vehicle value from vehicle serch box
    timeWeek: string;
    showPage: boolean = true;
    day: string;
    prefs: string;
    urlParams: Object;
    userPerm: any = JSON.parse(localStorage.getItem('userPerm')).perms;
    timesheetDetails: any; // stored in local storage
    startDateTime: Date;
    endDateTime: Date;
    private today = new Date();
    public myDateRangePickerOptions: IMyDrpOptions = {
        // other options...
        dateFormat: 'dd.mm.yyyy',
        firstDayOfWeek: 'mo',
        height: '44px',
        width: '220px',
        inline: false,
        alignSelectorRight: false,
        disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: (this.today.getDate() + 1) },
        editableDateRangeField: false,
        openSelectorOnInputClick: true
    };
    public dateRange: IMyDateRange;
    public showAuditTrail = true;
    public showArchived = false;
    public showPendingInvestigations = false;

    public showUseActivityFulfilled = true;
    public useActivityFulfilled: boolean;

    urlParaSub: any;
    hasTraceParamsInUrl: boolean = false;
    // List of vehicles to search
    vehicle: any = [];

    // List of vehicles groups -- may not be needed
    userVehicleGroupList: any = [];
    filteredVehicles: any = [];
    selectedVehicleId: number;
    urlPassedVehicleId: number;
    firstLoad: boolean = true;
    private vehicleList: any = [];

    localStoreSelectedVehicle: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SELECTED_VEHICLE_NAME));
    localSearchField: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SEARCH_FIELDS_NAME));
    localSearchDateDay: any = JSON.parse(localStorage.getItem(EventsSidebarComponent.LOCALSTORE_SEARCH_DATE_DAY));

    // Date buttons days
    dropdownTripsStopsSelect: string = 'today';
    dropdownTripsStops: any = [
        { value: 'today', viewValue: 'Today' },
        { value: 'yesterday', viewValue: 'Yesterday' },
        { value: 'custom', viewValue: 'Custom' }
    ];

    vehicleActivityTypeList: Array<VehicleActivityTypes> = [];
    vehicleActivityTypeSelect = new FormControl(null, []);

    vehicleGroupDepotList: Array<VehicleGroupDepots> = [];
    vehicleGroupDepotSelect = new FormControl(null, []);


    @Output() outputUseActivityFulfilled: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output() outputShowPage: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() outputShowAuditTrail: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() outputShowArchived: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() outputShowPendingInvestigations: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() outputVehicleName: EventEmitter<string> = new EventEmitter<string>();
    @Output() outputVehicleType: EventEmitter<string> = new EventEmitter<string>();
    @Output() outputVehicleId: EventEmitter<number> = new EventEmitter<number>();
    @Output() outputStartDateTime: EventEmitter<Date> = new EventEmitter<Date>();
    @Output() outputEndDateTime: EventEmitter<Date> = new EventEmitter<Date>();
    @Output() outputActivityType: EventEmitter<number> = new EventEmitter<number>();
    @Output() outputDepot: EventEmitter<number> = new EventEmitter<number>();
    // @Output() outputActivityTypeList: EventEmitter<VehicleActivityTypes[]> = new EventEmitter<VehicleActivityTypes[]>();


    @Output() outputTraceTitle: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() outputApiIsLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() activityListLoading: boolean = false;

    componentDestroyed$: Subject<boolean> = new Subject();


    vehicleSelectTemp = new FormControl(null, []);



    constructor(private router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private vehiclesGroupsService: VehiclesGroupsService,
        private activatedRoute: ActivatedRoute,
        private globalsPaths: GlobalsPaths,
        private vehicleService: VehiclesService,
        private apiSettings: APIsettings,
        private vehiclesFilesService: VehiclesFilesService
    ) {
    }

    ngOnInit() {

        const useActivityFulfilledValue = localStorage.getItem('useActivityFulfilled');
        if (useActivityFulfilledValue === 'true') {
            this.useActivityFulfilled = true;
        }

        this.vehicleCtrl = new FormControl();
        this.outputApiIsLoading.emit(true);
        this.getUsersVehicleGroups();
        const _selectedArr = this.vehicleActivityTypeList.filter(x => x.id > 5);

        // Set event type select item
        this.vehicleActivityTypeSelect.setValue(_selectedArr);
        this.outputActivityType.emit(this.vehicleActivityTypeSelect.value);

        // // Set the date range picker
        this.myDateRangePickerOptions.dateFormat = JSON.parse(localStorage.getItem('currentUser')).user.prefs.date_format.toLowerCase();
        this.setDateRangePickerValues();
        // Check if Trace parameters have been passed into urls
        this.urlParaSub = this.route.queryParams.subscribe(params => {

            if (params['vehicleId'] && params['startDate']) {
                const _vehicleId = params['vehicleId'];
                this.selectedVehicleId = parseInt(_vehicleId);
                this.urlPassedVehicleId = parseInt(_vehicleId);
                const _startDay = params['startDate'];
                this.day = this.datePipe.transform(_startDay, 'yyyy-MM-dd');

                this.hasTraceParamsInUrl = true;
            }
        });

        // this.determineDistance();

        if (this.userPerm.is_limited_user === false) {
            this.searchInf();
        }

        this.getVehicleActivityTypes();
        this.getVehicleGroupDepots();

        this.onChange();





    }

    onChange() {
        const vehicleNull = {
            id: null,
            registration: null,
            type: null
        }
        const _paginationParams: PaginationParams = { pageSize: 25, page: 1, orderingDirection: '-', ordering: 'registration', search: '' };
        this.vehicleSelectTemp
            .valueChanges.debounceTime(300)
            .pipe(
                tap(() => {
                    this.isLoading = true;
                    this.vehicleActivityTypeSelect.setValue(null);
                }),
                switchMap((value: Vehicle) => {
                    if (value && typeof value !== 'object') {
                        return this.vehicleService.getVehiclesPaginatedV2(_paginationParams, value)
                            .pipe(finalize(() => this.isLoading = false));
                    }
                })
            )
            .subscribe(vehicles => this.filteredVehicles = vehicles['results']);

        this.vehicleActivityTypeSelect.valueChanges.subscribe(() => this.searchOnDay());
        this.vehicleGroupDepotSelect.valueChanges.subscribe(() => this.searchOnDay());


    }


    public clearVehicle() {
        /*console.log('clearVehicle clicked')*/
        this.vehicleSelectTemp.setValue(null);
        this.vehicleActivityTypeSelect.setValue(null);
        this.filteredVehicles = [];
        this.selectedVehicle = null;
        this.selectedVehicleId = null;
        this.getVehicleActivityTypes();
        this.searchOnDay();
    }

    public selectAFilteredVehicle(event) {
        // Null is when the user clears the selected vehicle
        if (event == null) {
            this.clearVehicle();
            this.setDateRangePickerValues();
        } else {
            // when the vehicle is selected we don't want to restrict the date range
            this.dateRange = null;
            this.startDateTime = null;
            this.endDateTime = null;

            // if we can't clear a vehicle
            const _selectedVehicle = event;
            const _vehicleType = _selectedVehicle ? _selectedVehicle.vehicle_type : null;
            this.selectedVehicleId = _selectedVehicle.id;
            this.selectedVehicle = _selectedVehicle;
            this.getVehicleActivityTypes(_vehicleType);

            // Filter activities on vehicle select
            this.searchOnDay();
        }
    }

    ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }



    onDateRangeChanged(event) {
        this.setDateRangePickerValues(event);
        this.searchOnDay();
    }

    getVehicleActivityTypes(vehicleTypeFilter?: string, filterOutInternal?: boolean) {
        this.vehiclesFilesService.getVehicleActivityTypes(vehicleTypeFilter, filterOutInternal).subscribe((data) => {
            /*console.log('Vehicle activity types' + data);*/
            this.vehicleActivityTypeList = data;
            // this.outputActivityTypeList.emit(data);
        });
    }

    getVehicleGroupDepots() {
        this.vehiclesFilesService.getVehicleGroupDepots().subscribe((data) => {
            /*console.log('Vehicle group depots types' + data);*/
            this.vehicleGroupDepotList = data;
        });
    }

    public getUsersVehicleGroups() {
        const _paramsVG: PaginationParams = {
            pageSize: 400,
            page: 1,
            orderingDirection: '',
            ordering: 'name',
            search: ''
        };

        // Gets the vehicle groups and vehilces for the vehicle list o-content__sidebar
        this.vehiclesGroupsService.getVehiclesGroupsOnlyTrackers(_paramsVG)
            .takeUntil(this.componentDestroyed$)
            .subscribe(data => {
                const _data = data['vehicle_groups'];
                for (const i in _data) {
                    if (_data[i].vehicles.length > 0) {
                        this.userVehicleGroupList.push(_data[i]);
                        // Create a list of vehicles
                        for (const j in _data[i].vehicles) {
                            this.vehicleList.push(_data[i].vehicles[j]);
                        }
                    }
                }
                // Selected vehicle
                // this.selectVehicle();

                this.isLoading = false;

                // TODO - move this and have it check if the localstoarage is set and not waiting for this subscription to complete
                this.searchOnDay();
            });
    }

    private getSelectedVehicleById(vehicleId: number) {
        const _selectedVehicle = this.vehicleList.find(function (obj) { return obj.id === vehicleId; });
        return _selectedVehicle;
    }


    // Initialises the initial values for the search side bar.
    // Pulls previous stored params from local storage and sets the date picker
    public searchInf() {

        // Dont update the day date if it's been set by URL params
        if (!this.hasTraceParamsInUrl) {
            if (this.localSearchDateDay) {
                this.day = this.localSearchDateDay;
            } else {
                // Set dates for search
                const today = new Date();
                // Set to current todays date
                const dayFormated = this.datePipe.transform(today, 'yyyy-MM-dd');
                this.day = dayFormated;
            }
            this.setDateRangePickerValues();
        }

        // Can't output this until vehicle groups loaded?
        this.outputTraceTitle.emit(true);
        this.outputVehicleName.emit(this.searchAutocomplete);
        this.outputApiIsLoading.emit(true);
        this.isLoading = true;
        this.todayYesterday(this.day);
    };

    private setDateRangePickerValues(event?) {
        let _startDate;
        let _endDate;
        let _rangeStartDate: { year: number; month: number; day: number; };
        let _rangeEndDate: { year: number; month: number; day: number; };

        // If coming from a datepicker change interaction
        if (event) {
            // _startDate = new Date(event.beginJsDate);
            // _endDate = new Date(event.endJsDate);
            if (event.formatted.length > 0 || event.endEpoc > 0) {
                // const startDate = `${event.beginDate.day}-${event.beginDate.month}-${event.beginDate.year}`;
                // const endDate = `${event.endDate.day}-${event.endDate.month}-${event.endDate.year}`;
                _startDate = new Date(event.beginJsDate);
                _endDate = new Date(event.endJsDate);


                // this.madeInDatesText = `dates from ${startDate} to ${endDate}`;
            }
        } else {
            // Initialise the date range picker - initialise to todays date
            // _startDate = this.day != null ? new Date(this.day) : new Date();
            _startDate = new Date();
            _startDate.setHours(0, 0, 0, 0); // Set time to 00:00
            _endDate = new Date();
            _endDate.setHours(0, 0, 0, 0); // Set time to 00:00
            _rangeEndDate = {
                year: _startDate.getFullYear(), month: _startDate.getMonth() + 1, day: _startDate.getDate()
            };
            _startDate.setDate(_startDate.getDate() - 7);
            _rangeStartDate = {
                year: _startDate.getFullYear(), month: _startDate.getMonth() + 1, day: _startDate.getDate()
            };
            this.dateRange = {
                beginDate: _rangeStartDate,
                endDate: _rangeEndDate
            };

        }

        // Set start and end date Outputs and store in localstorage
        localStorage.setItem(EventsSidebarComponent.LOCALSTORE_SEARCH_DATE_DAY, JSON.stringify(moment(_startDate).format('YYYY-MM-DD')));
        this.startDateTime = _startDate;
        this.endDateTime = _endDate;

        // Move the end date time to midnight the next day
        // this.endDateTime.setHours(this.endDateTime.getHours() + 24);
    }

    public customFunctionality(option) {
        if (option === 'day' && this.dropdownTripsStopsSelect === 'custom') {
            return false;
        }
        return true;
    }

    public changeDateDayOption(event) {
        const today = moment(new Date()).format('YYYY-MM-DD');
        if (event === 'today') {
            this.day = today;
        } else if (event === 'yesterday') {
            this.day = moment(this.timeWeek).add(-1, 'days').format('YYYY-MM-DD');
        }
    }

    public addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    public toggleDay(option) {
        if (this.router.url !== '/timesheet') {
            const resultAddDay = this.addDays(this.day, option);
            const resultDate = moment(resultAddDay).format('YYYY-MM-DD');
            this.day = resultDate.toString();
        }
    }

    public todayYesterday(day) {
        const today = moment().format('YYYY-MM-DD');
        if (day === today) {
            this.dropdownTripsStopsSelect = 'today';
        } else {
            this.dropdownTripsStopsSelect = 'custom';
        }
    }

    public doSomthing(event) {
        /*console.log('DO SOMETHING: ', event);*/
        this.selectedVehicle = event.value;
        this.selectedVehicleId = event.value.id;
    }

    public showAuditTrialChanged() {
        this.searchOnDay();
    }

    public showArchivedChanged() {
        this.searchOnDay();
    }

    public showPendingInvestigationsChanged() {
        this.searchOnDay();
    }

    public useActivityFulfilledChanged() {

        this.outputUseActivityFulfilled.emit(this.showUseActivityFulfilled);
        this.isLoading = false;
        this.outputShowPage.emit(this.showPage);
        /*const getValue = localStorage.getItem('useActivityFulfilled');
        if (getValue === 'false') {
            this.useActivityFulfilled = true;
            localStorage.setItem('useActivityFulfilled', JSON.stringify(this.useActivityFulfilled));
        } else {
            this.useActivityFulfilled = false;
            localStorage.setItem('useActivityFulfilled', JSON.stringify(this.useActivityFulfilled));
        }*/
    }

    // public selectVehicle(vehicle?: any) {
    //     // // If the vehicle id is passed in as a parameter
    //     if (this.urlPassedVehicleId && this.firstLoad === true) {
    //         this.selectedVehicleId = this.urlPassedVehicleId;
    //         // const _selectVehicle = this.getSelectedVehicleById(this.urlPassedVehicleId);
    //         this.selectedVehicle = { id: vehicle.id, registration: vehicle.registration, type: vehicle.manufacturer_model.vehicle_type.reference };
    //         this.firstLoad = false;
    //         return;
    //     } else if (vehicle) {
    //         this.selectedVehicle = { id: vehicle.id, registration: vehicle.registration, type: vehicle.type };
    //         this.selectedVehicleId = vehicle.id;
    //         return;
    //     } else if (this.localStoreSelectedVehicle != null && this.localStoreSelectedVehicle.id !== undefined) {
    //         // get the vehicle id from local storage
    //         const vehicle = this.localStoreSelectedVehicle;
    //         this.selectedVehicle = { id: vehicle.id, registration: vehicle.registration, type: vehicle.type };
    //         this.selectedVehicleId = vehicle.id;
    //         return;
    //     } else {
    //         // get the first vehilce in the first group
    //         const groupList = this.userVehicleGroupList;
    //         const firstVehicle = groupList[0].vehicles[0];
    //         this.selectedVehicle = { id: firstVehicle.id, registration: firstVehicle.registration, type: firstVehicle.type };
    //         this.selectedVehicleId = firstVehicle.id;
    //     }
    // };

    public validSearch(validWeek, validVehicle) {
        if (validWeek === false && validVehicle === false) {
            return false;
        } else {
            return true;
        }
    };

    // Called when 'Search' button clicked
    public searchOnDay() {
        /*console.log('searchOnDay selected vehicle: ', this.selectedVehicle);*/
        localStorage.setItem(EventsSidebarComponent.LOCALSTORE_SELECTED_VEHICLE_NAME, JSON.stringify(this.selectedVehicle));

        this.outputVehicleName.emit(this.selectedVehicle && this.selectedVehicle.registration ? this.selectedVehicle.registration : null);
        this.outputVehicleId.emit((this.selectedVehicle ? this.selectedVehicle.id : null));
        this.outputVehicleType.emit((this.selectedVehicle ? this.selectedVehicle.vehicle_type : null));
        this.outputStartDateTime.emit(this.startDateTime);
        this.outputEndDateTime.emit(this.endDateTime);
        if (this.vehicleGroupDepotSelect.value) {
            this.outputDepot.emit(this.vehicleGroupDepotSelect.value.id);
        }
        this.outputActivityType.emit(this.vehicleActivityTypeSelect.value ? this.vehicleActivityTypeSelect.value.id : 0);
        this.outputShowAuditTrail.emit(this.showAuditTrail);
        this.outputShowArchived.emit(this.showArchived);
        this.outputShowPendingInvestigations.emit(this.showPendingInvestigations);
        this.showPage = true;
        this.outputApiIsLoading.emit(false);
        this.isLoading = false;
        this.outputShowPage.emit(this.showPage); // force re-load of trace data

        return;

    };

    displayFn(user: Vehicle) {
        if (user) { return user.registration; }
    }

}

export interface ISelectedVehile {
    id: number;
    registration: string;
    type: string;
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Vehicle-file/components/vehicle-file-sidebar/vehicle-file-sidebar.ts